<template>
  <div>
    <register-title class="form__title">{{ $t("job info") }}</register-title>

    <form @submit.prevent="handleFormSubmit" class="form">
      <div class="select-container">
        <label for="tax-residence" class="label">{{
          $t("tax residency")
        }}</label>
        <exp-select
          :options="registrationCountryList()"
          v-model="form.tax_residency"
          :title="$t('choose country')"
        ></exp-select>
      </div>
      <register-input
        v-if="form.tax_residency != 92"
        componentID="taxpayer-number"
        :label="$t('taxpayer number')"
        inputType="text"
        :inputPlaceholder="$t('taxpayer number')"
        :isRequired="true"
        v-model="form.tax_payer_number"
        class="form__input"
      />
      <register-input
        componentID="work-place"
        inputType="text"
        :label="$t('work place position')"
        :inputPlaceholder="$t('work place position')"
        :isRequired="true"
        v-model="form.work_place"
        class="form__input"
      />
      <question-input
        componentID="is-individual"
        :defaultValue="form.is_individual ? 'yes' : 'no'"
        :question="$t('entrepreneurial/license activity')"
        class="form__input"
        @handleSelect="value => (form.is_individual = value === 'yes' ? 1 : 0)"
      ></question-input>
      <button class="button filled form__button">{{ $t("confirm") }}</button>
    </form>
  </div>
</template>

<script>
import QuestionInput from "@/components/register/QuestionInput";
import RegFormMixin from "../form_mixin";
import { FhsAxios } from "../../../services/axios";

export default {
  props: ["user_profile"],
  data() {
    return {
      is_kaz_citizen: true,
      old_form: null,
      form: {
        tax_residency: null,
        tax_payer_number: null,
        work_place: null,
        is_individual: 1
      }
    };
  },
  components: {
    QuestionInput
  },
  mixins: [RegFormMixin],
  watch: {
    user_profile: function(value) {
      this.fetchForm();
    }
  },
  methods: {
    isFormChanged() {
      return JSON.stringify(this.old_form) !== JSON.stringify(this.form);
    },
    fetchForm() {
      try {
        Object.entries(this.user_profile.userProfile).map(obj => {
          if (obj[0] in this.form) {
            this.form[obj[0]] = obj[1];
          }
        });
        this.form.is_individual = this.user_profile.userProfile.is_individual
          ? 1
          : 0;
        this.old_form = JSON.parse(JSON.stringify(this.form));
      } catch (e) {
        // ERROR HANDLER
      }
    },
    nextStep() {
      if (this.form.is_individual === 1) {
        this.$router.push({ name: "individual-entrepreneur" });
        return;
      }
      this.$router.push({ name: "representatives-info-list" });
    },
    saveData() {
      this.$emit("loading-status", true);
      let url = `user/profile`;
      FhsAxios.post(url, this.form).then(res => {
        if (res.data.status) {
          this.$toasted.success(this.$t("data saved"));
          this.nextStep();
          return;
        }
        this.$toasted.error(this.$t("data saved"));
        this.$emit("loading-status", false);
      });
    },
    handleFormSubmit() {
      if (!this.isFormChanged()) {
        this.nextStep();
      } else {
        this.saveData();
      }
    }
  },
  beforeMount() {
    this.fetchForm();
  }
};
</script>
